import http from '@api'
import SectionLayout from '@component/layout/section'
import { get, map, range } from 'lodash-es'
import OfficeTeamContent from './content'

const pageIndex = 1
const pageSize = 8
export default async function OfficeTeam({
  data
}) {

  const [list, totals] = await getData(data.id)
  return (
    <SectionLayout title='Our team'>
      <OfficeTeamContent defaultData={list} id={data.id} pageIndex={pageIndex} pageSize={pageSize} totals={totals}></OfficeTeamContent>
    </SectionLayout>
  )
}

async function getData(id) {
  const data = await http.get(`office/${id}/agents`, {limit: pageSize, offset: (pageIndex - 1) * pageSize})
  return [
    data,
    get(data, 'headers.x-total-count')
  ]
}

export function SkeletonOfficeTeam({
  showTitle = false
}) {

  return (
    <div className='skeleton-wrap'>
      {showTitle && <span className='h-20 w-1/6 mb-20'></span>}
      <div className='grid grid-cols-1 md:grid-cols-4 gap-16'>
        {
          map(range(0, 8), idx => (
            <span key={idx} className='h-148'></span>
          ))
        }
      </div>
    </div>
  )
}